





















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Transaction, Expense } from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import TransactionListItem from "@/shared/components/ui/TransactionListItem.vue";
import PendingAmountRow from "@/shared/components/cash/PendingAmountRow.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import _ from "lodash";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    PendingAmountRow,
    Widget,
    TransactionListItem,
    Pagination
  }
})
export default class CashAccountTab extends Vue {

  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  page: number;

  @Prop()
  pageCount: number;

  @Prop()
  transactionsForCurrentPage: Transaction[];

  @Prop({ required: false, default: 10 })
  pageSize: number;

  @Prop({ required: false, default: 0 })
  pendingAmount: number | false;

  @Prop({ required: false, default: null })
  getExpensesForReimbursement: (t: Transaction) => Expense[];

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  get cashAccountHasPendingAmountSet (): boolean {
    return this.pendingAmount !== false && this.pendingAmount !== 0;
  }

  get cashAccountPendingAmount (): number {
    return this.pendingAmount ? this.pendingAmount : 0;
  }

  expensesForReimbursement (item: Transaction): Expense[] {
    if (!this.getExpensesForReimbursement) {
      return null; // kind of weird, but existing code passed a null for no items
    }
    return this.getExpensesForReimbursement(item);
  }

  get transactionGridItemCount (): number {
    return this.transactionsForCurrentPage.length + (this.cashAccountHasPendingAmountSet ? 1 : 0);
  }

  get hasFooter () {
    return this.custodianSettingsStore.cashAccountFooter;
  }

  get widgetTitle () {
    const pluralization = this.transactionsForCurrentPage.length !== 1 ? "s" : "";
    const asterisk = this.hasFooter ? "*" : "";
    return `${this.transactionGridItemCount} Transaction${pluralization}${asterisk}`;
  }
}

